/** @jsx $jsx */
import { $jsx } from 'framework7';
function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
    $on = _ref.$on,
    $update = _ref.$update;
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="/" class="link">
          <i class="material-icons">home</i>
          <span class="if-not-md">Home</span>
        </a>
      </div>
      <div class="title">Forbidden</div>
    </div>
  </div>
  <div class="page-content">
    <div class="block-title">Unauthorized content</div>
    <div class="block block-strong">
      <p>You don't have required permissions to display this content.</p>
    </div>
    <div class="block-footer">
      <p>© AppDigCab, 2023-2024 (v2.0)</p>
    </div>
  </div>
</div>
`
    }
    ;
}
framework7Component.id = 'c3b91dba95';
export default framework7Component;